import { z } from 'zod';
import { isDeltaNotEmpty } from '@/lib/quill';

export const postCommentSchema = z.object({
  comment: z.any().refine(isDeltaNotEmpty, "Comment can't be empty"),
});
